import checkBreakpoint from '@/client/src/js/utils/checkBreakpoint';
import debounce from 'lodash.debounce';

/**
 * Move element after another referenced element in the DOM
 *
 * @param {HTMLElement} el The element to be moved.
 * @param {HTMLElement} referenceNode The node that will be referenced for the new position.
 */
const insertAfter = (el, referenceNode) => {
  referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
};

/**
 * Maintain DOM Sequential order when columns need to switch on mobile.
 *
 * @param {object} allColumnsBlocks The Columns HTML Element
 */
const handleColumnsBlockResponsive = (allColumnsBlocks) => {
  const breakpointCheck = checkBreakpoint();

  // Loop through all columns blocks
  allColumnsBlocks.forEach((columnsBlock) => {
    const allColumns = columnsBlock.querySelectorAll('.wp-block-column');
    const switchCheck = columnsBlock.classList.contains('switch-columns-mobile');

    // Check length and custom switch option from editor
    if (allColumns.length === 2 && switchCheck === true) {
      const columnOne = allColumns[0];
      const columnTwo = allColumns[1];

      if (breakpointCheck === 'mobile' && columnsBlock.classList.contains('wp-block-columns--mobile') === false) {
        // Set to mobile order
        insertAfter(columnOne, columnTwo);
        columnsBlock.classList.add('wp-block-columns--mobile');
      } else if (breakpointCheck === 'desktop' && columnsBlock.classList.contains('wp-block-columns--mobile') === true) {
        // Reset to desktop order
        insertAfter(columnOne, columnTwo);
        columnsBlock.classList.remove('wp-block-columns--mobile');
      }
    }
  });
};

/**
 * Init columns block custom functionality
 */
const init = () => {
  const allColumnsBlocks = document.querySelectorAll('.wp-block-columns');

  // Check there are columns blocks
  if (allColumnsBlocks.length === 0) {
    return;
  }

  // Check and set initial responsive state
  handleColumnsBlockResponsive(allColumnsBlocks);

  // Debounce for responsive behavior
  window.addEventListener('resize', debounce(() => {
    handleColumnsBlockResponsive(allColumnsBlocks);
  }, 300));
};

export default init;
